import { render, staticRenderFns } from "./guesslikeCard.vue?vue&type=template&id=f098752c&scoped=true&"
import script from "./guesslikeCard.vue?vue&type=script&lang=js&"
export * from "./guesslikeCard.vue?vue&type=script&lang=js&"
import style0 from "./guesslikeCard.vue?vue&type=style&index=0&id=f098752c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f098752c",
  null
  
)

export default component.exports